import { ChangeToMemberMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const changeToMemberHandler = graphql.mutation<ChangeToMemberMutation>(
  "changeToMember",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        changeToMember: {
          result: true,
        },
      },
    });
  }
);
